import { Paper, Box, Typography, Chip, useTheme, alpha } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React, { useContext } from 'react';
import CreateShipmentContext from '../../../../context/CreateShipment';
import { createShipmentContextType } from '../../../../types/shipment';

interface Props {
  pendingRequirements: { label: string; boxIndex?: number }[];
}

export function PendingRequirementsBlock({ pendingRequirements }: Props) {
  const theme = useTheme();
  const { boxes, setSelectedBox } = useContext(CreateShipmentContext) as createShipmentContextType;

  if (!pendingRequirements || pendingRequirements.length === 0) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: '12px',
        border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}`,
        bgcolor: alpha(theme.palette.warning.main, 0.04),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <InfoOutlinedIcon sx={{ color: 'warning.main', fontSize: 20 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.875rem' }}>
          Pending requirements:
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {pendingRequirements.map((req, i) => (
          <Chip
            key={i}
            label={req.label}
            size="small"
            onClick={() => {
              if (req.boxIndex !== undefined && boxes[req.boxIndex]) {
                setSelectedBox(boxes[req.boxIndex]);
              }
              if (req.label.includes('Recipient VAT')) {
                const vatField = document.querySelector('input[name="recipientVatTaxId"]') as HTMLElement;
                if (vatField) {
                  vatField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  vatField.focus();
                }
              } else if (req.label.includes('Freight') || req.label.includes('Incoterm')) {
                const frField = document.querySelector('input[name="freight"]') as HTMLElement;
                if (frField) {
                  frField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  frField.focus();
                }
              }
            }}
            sx={{
              bgcolor: alpha(theme.palette.warning.main, 0.1),
              color: theme.palette.warning.dark || '#b78103',
              border: `1px solid ${alpha(theme.palette.warning.main, 0.35)}`,
              fontSize: '0.75rem',
              fontWeight: 600,
              cursor: 'pointer',
              '&:hover': { bgcolor: alpha(theme.palette.warning.main, 0.18) },
            }}
          />
        ))}
      </Box>
    </Paper>
  );
}

export default PendingRequirementsBlock;
